export default __webpack_public_path__ + "879546f1555d1fa50b64cc8f7c1304b3.png";